import React from 'react'
import { Tooltip } from 'react-tippy'
function Tip(props){

  return (
    <Tooltip
      position={'bottom'}
      theme={'light'}
      html={ props.children }
    >
      &nbsp;<span className={'mtt-variations__tooltip variation-tooltip'} />
    </Tooltip>
  )
}

export default Tip